import React, { Component } from "react";
import { RequestorInfoCard } from "./RequestorInfoCard";
import { PickupAddressCard } from "./PickupAddress";
import { FreightTypeChoice} from './FreightTypeChoice';
import { VehicleDetailsCard } from "./VehicleDetailsCard";
import { ContainerDetailsCard } from "./ContainerDetailsCard";
import { ConsigneeDetails } from  "./ConsigneeDetails";
import { PayerDetails } from  "./PayerDetails";
import { PriceEstimateCard } from  "./PriceEstimateCard";
import { Constants } from "../../Constants";
import { FirstTimeShipperDetails } from "./FirstTimeShipperDetails";
import {  RecoilRoot,  atom,  selector,  useRecoilState,  useRecoilValue,} from 'recoil';

export class BookingRequest extends Component{
    constructor(props) {
        super(props);
        this.state = {
            transportType: null, // inlandAndOceanFreight, oceanFreightOnly
            freightType: null,  // vehicle, container
            transportTypeSelected: false,
            freightTypeSelected: false,
            payerSelected: false,

            formSubmitting: false,
            submitButtonText: "Submit Booking Request",
            fileUploadsMayTakeTimeText: null,
            firstTimeShipper: false,
            powerOfAttorneyAgreed: false,
            
            selectedOriginPort: null,            
            selectedDestinationPort: null,            
        };  
        // This binding is necessary to make `this` work in the callback
        this.changeTransportType = this.changeTransportType.bind(this);
        this.changeFreightType = this.changeFreightType.bind(this);
        this.setPayerSelected = this.setPayerSelected.bind(this);
        this.updateFirstTimeShipper = this.updateFirstTimeShipper.bind(this);
        this.updatePowerOfAttorneySigned = this.updatePowerOfAttorneySigned.bind(this);

        this.setFormSubmitting = this.setFormSubmitting.bind(this);
        this.updateOriginPort = this.updateOriginPort.bind(this);
        this.updateDestinationPort = this.updateDestinationPort.bind(this);
    }
    updateOriginPort = (port) => {
        this.setState({selectedOriginPort: port});
    }
    updateDestinationPort = (port) => {
        this.setState({selectedDestinationPort: port});
    }
    estimatedPriceCollector = atom({
        key: 'estimatedPriceCollector', // unique ID (with respect to other atoms/selectors)
        default: {"serviceType":"", "port":""}, // default value (aka initial value)
      });

    updatePowerOfAttorneySigned = (value) => this.setState({powerOfAttorneyAgreed : value});

    setFormSubmitting = (value) => {
        if(value){
            this.setState({submitButtonText: "Please wait...",
                formSubmitting: value});
            this.setState({fileUploadsMayTakeTimeText: <em>*Submission may take longer if many documents are being uploaded</em>});
        }else{
            this.setState({formSubmitting: value});
        }
    };
    changeTransportType = (e) => {this.setState({transportType: e, transportTypeSelected: true}); };
    changeFreightType = (e) => {
        this.setState({freightType: e, freightTypeSelected: true}); 
    };    
    setPayerSelected = (e) => {
        this.setState({payerSelected: true}); 
    };
    updateFirstTimeShipper = (isFirstTimeShipper) => {
        this.setState({firstTimeShipper: isFirstTimeShipper}); 
    };
    
    transportTypeChoice =
        <div className="col-12">
            <div className="row">                    
                <strong>{Constants.SelectYourService}</strong>
                <div className="form-check my-1">
                    <input type="radio" className="form-check-input"
                        id="Inland-Ocean-Transport" name="transportType" value="inlandAndOceanFreight"
                        onClick={() => this.changeTransportType("inlandAndOceanFreight")}/>
                    <label className="form-check-label" htmlFor="Inland-Ocean-Transport">
                        {Constants.InlandAndOceanFreightDescription}
                        <i className="ml-1 fa fa-truck"></i>
                        <i className="ml-1 fa fa-plus"></i>
                        <i className="ml-1 fa fa-ship"></i>
                    </label>
                </div>
                <div className="form-check mb-1">
                    <input type="radio" className="form-check-input"
                        id="Ocean-Transport" name="transportType" value="oceanFreightOnly"
                        onClick={() => this.changeTransportType("oceanFreightOnly")}/>
                        
                    <label className="form-check-label" htmlFor="Ocean-Transport">
                        {Constants.OceanFreightOnlyDescription}
                        <i className="ml-1 fa fa-ship"></i>
                    </label>
                </div>
            </div>
        </div>

    firstTimeShipperChoice = 
        <div className="col-12 mb-2">
            <strong>Is this your first time shipping with us?</strong>
            <div className="form-check form-check-inline my-1 ml-2">
                <input type="radio" className="form-check-input"
                    id="First-Time-Shipper" name="firstTimeCustomer" value={true}
                    onClick={() => this.updateFirstTimeShipper(true) }/>
                <label className="form-check-label" htmlFor="First-Time-Shipper">
                    Yes
                </label>
            </div>
            <div className="form-check form-check-inline mb-1">
                <input type="radio" className="form-check-input"
                    id="Not-First-Time-Shipper" name="firstTimeCustomer" defaultChecked={true} value={false}
                    onClick={() => this.updateFirstTimeShipper(false)}/>
                    
                <label className="form-check-label" htmlFor="Not-First-Time-Shipper">
                    No
                </label>
            </div>
        </div>

    render(){
        // All JSX elements initially set to null.
        var firstTimeShipperInput, requestorInfo, pickupAddress, freightTypeChoice, freightTypeDetails,
            payerInfo, consigneeDetails, submitButton;        
        
        if(this.state.firstTimeShipper){
            firstTimeShipperInput = <FirstTimeShipperDetails onChange={this.updatePowerOfAttorneySigned}/>;
        }

        // The following logic assigns the appropriate elements with props to them
        if(this.state.transportTypeSelected){
            if(this.state.transportType === "inlandAndOceanFreight"){
                pickupAddress  = <PickupAddressCard />
            }
            requestorInfo = <RequestorInfoCard />
            freightTypeChoice = <FreightTypeChoice onChoiceChange={this.changeFreightType}
                onOriginPortChange={this.updateOriginPort} onDestinationPortChange={this.updateDestinationPort}/> 
        }
        
        if(this.state.freightTypeSelected){
            if(this.state.freightType === "vehicle"){
                freightTypeDetails = <VehicleDetailsCard id="freightDetails" maxVehicles={20}/>;
            }else{
                freightTypeDetails = <ContainerDetailsCard maxContainers={5}/>;
            }
            payerInfo = <PayerDetails changeWhoPayerIs={this.setPayerSelected}/>;
        }

        if(this.state.payerSelected){
            consigneeDetails = ConsigneeDetails();
        }

        if(this.state.freightTypeSelected && this.state.transportTypeSelected
            && this.state.payerSelected)
        {
            submitButton = 
                <div className="col-12 mb-3">
                    <hr/>
                    <button type="submit" disabled={this.state.formSubmitting}
                    className="btn btn-primary btn-lg btn-block">
                        {this.state.submitButtonText}
                    </button>
                    {this.state.fileUploadsMayTakeTimeText}
                    <hr />
                    <div className="alert alert-warning">
                        <strong>Please note:</strong> Orders will be processed in the order that they are received. <br />
                        Vehicle titles or high heavy equipment bill of sales must be re-assigned to the Shipper’s name except for Foreign Shippers (no U.S. address) where they must be re-assigned to the U.S. supplier’s name.
                    </div>
                    
                </div>
                
        }

        var printableFormsInfo = <div className="col-12 mb-2 text-center">
                                    <div className="alert alert-info alert-dismissible fade show" role="alert">
                                        Making a booking request with Angelic via this online form is fast and simple. We make sure to collect all the information needed for your booking in one spot.<br />                                    
                                        If you would like to download, print and email the forms instead, you can find the printable version&nbsp;
                                        <a href="https://angelicshipping.com/printable-shipping-forms" 
                                            target="_blank" rel="noopener noreferrer"><strong>here</strong></a>                                        
                                        
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>
        var estimatedPrice;
        if(this.state.freightTypeSelected){            
            var priceBreakdown = [];
            var totalPrice = 0.0;
            priceBreakdown.push(<strong>Estimated price breakdown:</strong>);
            if(this.state.freightType === "vehicle"){
                if(this.state.selectedOriginPort === "Freeport, Texas"){
                    priceBreakdown.push(<div>RoRo service from {this.state.selectedOriginPort} port: ${Constants.roroCentralUsPrice}</div>);
                    totalPrice += Constants.roroCentralUsPrice;
                }else{
                    priceBreakdown.push(<div>RoRo service from {this.state.selectedOriginPort} port: ${Constants.roroEastUsPrice}</div>);
                    totalPrice += Constants.roroEastUsPrice;
                }
            }
            else if(this.state.freightType === "container"){
                priceBreakdown.push(<div>Container pricing is variable and will be provided once we receive your request</div>);
            }                    
            if(this.state.transportType === "inlandAndOceanFreight"){
                priceBreakdown.push(<em>Additional charges for shipping freight to port will apply</em>)
            }
            // estimatedPrice = 
            //     <PriceEstimateCard serviceType={this.state.transportType} freightType={this.state.freightType} 
            //         originPort={this.state.selectedOriginPort} destinationPort={this.state.selectedDestinationPort}/>
        }

        return(  
            <RecoilRoot>
                <div className="container-lg mb-5">
                    <form method="post" action="/BookingRequest" encType="multipart/form-data" 
                        onSubmit={() => this.setFormSubmitting(true)}>
                        <div className="row my-2">
                            {printableFormsInfo}
							<em className="mb-2">Need help? You can review our video guide to filling out this form by clicking <a href="https://youtu.be/Hf39dgdZ4u4" target="_blank" rel="noreferrer noopener">here</a></em>
							<hr />
                            {this.firstTimeShipperChoice}
                            {firstTimeShipperInput}
                            {this.transportTypeChoice}
                            {requestorInfo}
                            {pickupAddress}
                            {freightTypeChoice}                            
                            {estimatedPrice}
                            {freightTypeDetails}
                            {payerInfo}
                            {consigneeDetails}
                            {submitButton}
                            <div className="col-12" style={{"minHeight":"25vh"}}></div> 
                        </div>                
                    </form>
                </div>   
            </RecoilRoot> 
        );
    }
}